import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { Btn, Input, Panel } from "@/forum/ui";
import { Editor } from "@/forum/Editor";

export default function NewThreadPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post(`/forum/categories/${slug}/threads`, { title, content });
      toast.success("Téma létrehozva");
      nav(`/forum/t/${data.id}`);
    } catch (ex) {
      toast.error(errorText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl space-y-6" data-testid="new-thread-page">
      <Link to={`/forum/c/${slug}`} className="inline-flex items-center gap-1 font-mono text-[11px] tracking-widest text-white/50 hover:text-white" data-testid="back-to-category"><ChevronLeft size={12} />VISSZA</Link>
      <h1 className="font-display text-3xl font-bold">Új téma</h1>
      <Panel className="p-6 sm:p-8">
        <form onSubmit={submit} className="space-y-4">
          <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Téma címe" required minLength={3} maxLength={140} data-testid="thread-title-input" />
          <Editor value={content} onChange={setContent} rows={12} placeholder="Írd le a témát… (Markdown támogatott)" testId="thread-editor" />
          <div className="flex justify-end">
            <Btn type="submit" disabled={busy || title.trim().length < 3 || content.trim().length < 2} data-testid="thread-submit">Téma közzététele</Btn>
          </div>
        </form>
      </Panel>
    </div>
  );
}
